import React from "react";
import { useTranslation } from "react-i18next";
import GuestDropdown from "./GuestDropdown";
import { priceBreakdown } from "../../helper/bookingPrice";
import StayDatePicker from "./StayDatePicker";

const BookingCard = ({
  className = "",
  step,
  arrivalDate,
  departureDate,
  disabledDates,
  minimumStayMap,
  onDatesChange,
  getDayClassName,
  renderDayContents,
  guestLiClassName = "icnWrapList",
  total,
  priceLines = [],
  currency,
  formatMoney,
  roomHint = null,
  guestLimits,
  guestErrors = false,
  guestFocus = 0,
}) => {
  const { t } = useTranslation();
  const breakdown = priceBreakdown(priceLines);
  const label = (row) => {
    switch (row.type) {
      case "accommodation":
        return t("accommodation", { defaultValue: "Accommodation" });
      case "upsell":
        return row.name;
      case "voucher":
        return row.percent ? `${t("voucher_discount")} (${row.percent}%)` : t("voucher_discount");
      default:
        return t(row.type);
    }
  };

  return (
    <div className={`appartSpecsWrap custom-box-apartment ${className}`}>
      <div className='appartDescrTextWrap'>
        <ul className='listUnstyled dateTimeInfo'>
          <StayDatePicker
            step={step}
            arrivalDate={arrivalDate}
            departureDate={departureDate}
            bookedDates={disabledDates}
            minimumStayMap={minimumStayMap}
            onChange={onDatesChange}
            getDayClassName={getDayClassName}
            renderDayContents={renderDayContents}
          />
          <li className={guestLiClassName}>
            <GuestDropdown
              step={step}
              limits={guestLimits}
              showErrors={guestErrors}
              focusToken={guestFocus}
            />
          </li>
        </ul>
        <div className='totalRow'>
          <div className='icnDescrWrap'>
            <p>{t("total")}</p>
          </div>
          <strong className='appartPrice'>
            {formatMoney(total, 2, currency)}
          </strong>
        </div>
        {breakdown.length > 0 && (
          <ul className='listUnstyled booking-card__breakdown'>
            {breakdown.map((row, index) => (
              <li key={`${row.type}-${index}`}>
                <span>{label(row)}</span>
                <span>
                  {row.amount < 0
                    ? `-${formatMoney(-row.amount, 2, currency)}`
                    : formatMoney(row.amount, 2, currency)}
                </span>
              </li>
            ))}
          </ul>
        )}
        {roomHint && <p className='select-room-hint'>{roomHint}</p>}
      </div>
    </div>
  );
};

export default BookingCard;
